<template>
  <div id="informationManagement">
    <el-card>
      <el-form :model="searchForm" ref="searchForm" label-position="top" @keyup.enter.native="handleSearch">
        <el-row>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Rep. Office:" prop="repOffice">
              <el-select filterable clearable v-model="searchForm.repOffice" placeholder="Please select">
                <el-option v-for="item in repOfficeList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Name:" prop="accountName">
              <el-input clearable v-model="searchForm.accountName" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Service No. (GTS):" prop="serviceNo">
              <el-input clearable v-model="searchForm.serviceNo" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Level:" prop="accountLevel">
              <el-select clearable v-model="searchForm.accountLevel" placeholder="Please select">
                <el-option v-for="item in accountLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Industry:" prop="industry">
              <el-select filterable clearable v-model="searchForm.industry" placeholder="Please select">
                <el-option v-for="item in industryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Marketing KA/WLA:" prop="marketingKA">
              <el-select clearable v-model="searchForm.marketingKA" placeholder="Please select">
                <el-option v-for="item in marketingKAList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="WLA:" prop="wla">
              <el-select clearable v-model="searchForm.wla" placeholder="Please select">
                <el-option v-for="item in wlaList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="VIP Code:" prop="vipCode">
              <el-input clearable v-model="searchForm.vipCode" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Creation Time:" prop="creationTime">
              <el-date-picker
                v-model="searchForm.creationTime"
                type="daterange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xl="24" :lg="8" :md="24" class="btn-col" style="text-align: right;">
            <el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
            <el-button size="small" @click="handleReset()">Reset</el-button>
            <el-button size="small" :loading="exportLoading" @click="handleExport()">Export</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" @sort-change="handleSortChange">
        <el-table-column prop="accountName" label="Account Name" align="left" min-width="180" fixed="left" :show-overflow-tooltip="true" sortable="custom">
          <template slot-scope="scope">
            <a style="color:blue;cursor:pointer;" @click="handleDetail(scope.row)">{{ scope.row.accountName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="country" label="Rep. Office" align="left" min-width="120" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="gtsCode" label="Account Service No. (GTS)" align="center" min-width="150" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="accountLevel" label="Account Level" align="center" min-width="140" :show-overflow-tooltip="true" sortable="custom">
          <template slot-scope="scope">
            <span :class="'level-badge level-' + getLevelClass(scope.row.accountLevel)">{{ scope.row.accountLevel }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="accountIndustry" label="Account Industry" align="center" min-width="170" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="marketingKa" label="Marketing KA/WLA" align="center" min-width="180" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <!-- <el-table-column prop="wla" label="WLA" align="center" min-width="80" :show-overflow-tooltip="true" sortable="custom">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.wla === true ? '#52C41A' : '', fontWeight: scope.row.wla === true ? '500' : 'normal' }">{{ scope.row.wla === true ? 'Yes' : 'No' }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="vipCode" label="VIP Code" align="center" min-width="130" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="asmNames" label="Account Service Manager" align="center" min-width="170" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="engineerNames" label="Engineer" align="center" min-width="170" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column v-if="hasOperationPermission" prop="operation" label="Operation" align="center" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleModify(scope.row)">Modify</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pageDiv" v-if="totalCount && totalCount > 0">
        <el-pagination
          small
          layout="total, prev, pager, next, sizes, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalCount"
          @size-change="changePageSize"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- Modify Dialog -->
    <el-dialog
      title="Modify VIP Code, Account Level, Account Service Manager & Engineer"
      width="820px"
      :visible.sync="modifyVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="modifyForm" ref="modifyForm" label-position="top">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Rep. Office:" prop="country">
              <el-input v-model="modifyForm.country" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Account Name:" prop="accountName">
              <el-input v-model="modifyForm.accountName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Account Service No. (GTS):" prop="gtsCode">
              <el-input v-model="modifyForm.gtsCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Account Industry:" prop="accountIndustry">
              <el-input v-model="modifyForm.accountIndustry" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Marketing KA/WLA:" prop="marketingKa">
              <el-input v-model="modifyForm.marketingKa" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 71px">
            <!-- <el-form-item label="WLA:" prop="wla">
              <el-input :value="modifyForm.wla === true ? 'Yes' : 'No'" disabled></el-input>
            </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <el-form-item label="Account Level:" prop="accountLevel" :rules="[{ required: true, message: 'Please select Account Level', trigger: 'change' }]">
              <el-select clearable v-model="modifyForm.accountLevel" placeholder="Please select">
                <el-option v-for="item in accountLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="VIP Code:" prop="vipCode">
              <el-input clearable v-model="modifyForm.vipCode" placeholder="Please input" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Account Service Manager:" prop="asmList">
              <el-select
                v-model="modifyForm.asmList"
                multiple
                clearable
                filterable
                remote
                placeholder="Please input Employee No. or Employee Name"
                :remote-method="value => filterUser('asmSearchList', value)"
              >
                <el-option v-for="item in asmSearchList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Engineer:" prop="engineerList">
              <el-select
                v-model="modifyForm.engineerList"
                multiple
                clearable
                filterable
                remote
                placeholder="Please input Employee No. or Employee Name"
                :remote-method="value => filterUser('engineerSearchList', value)"
              >
                <el-option v-for="item in engineerSearchList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="modifyVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="modifyLoading" @click="saveModify()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'informationManagement',
  created() {
    this.checkOperationPermission()
    this.initDropdownData()
    this.handleSearch()
  },
  activated() {
    // 从 majorProject 详情返回时，自动恢复到之前的 accountDetail 页面
    const returnInfo = sessionStorage.getItem('valuedAccountReturnInfo')
    if (returnInfo) {
      sessionStorage.removeItem('valuedAccountReturnInfo')
      try {
        const { accountId, activeTab } = JSON.parse(returnInfo)
        if (accountId) {
          this.$router.push({
            name: 'accountDetail',
            params: { id: accountId },
            query: { from: 'informationManagement', activeTab: activeTab || 'majorProject' }
          })
        }
      } catch (e) {}
    }
  },
  data() {
    return {
      moment,
      // Search form
      searchForm: {},
      // Dropdown options
      repOfficeList: [],
      accountLevelList: [],
      industryList: [],
      marketingKAList: [],
      wlaList: ['Yes', 'No'],
      // Table
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      exportLoading: false,
      // Sort
      sortField: '',
      sortOrder: '',
      // Modify dialog
      modifyVisible: false,
      modifyLoading: false,
      modifyForm: {},
      asmSearchList: [],
      engineerSearchList: [],
      // Permission
      hasOperationPermission: false,
    }
  },
  methods: {
    initDropdownData() {
      // keyValue/queryLabelList: AccountLevel, MarketingKa
      let kvUrl = `${this.$store.state.islhurl}keyValue/queryLabelList?`
      const kvKeys = ['AccountLevel', 'MarketingKa']
      kvKeys.forEach((k, i) => { kvUrl += (i === 0 ? '' : '&') + `keyList=${k}` })
      this._get(kvUrl).then(res => {
        if (res.code === 200 && res.data) {
          this.accountLevelList = res.data.AccountLevel || []
          this.marketingKAList = res.data.MarketingKa || []
        }
      }).catch(() => {})
      // lov/ipms/options: Representative Office, Sub Industry
      const lovCodes = 'HPFM.SUB_INDUSTRY,HPFM.OVERSEA_COUNTRY'
      const lovUrl = `${this.$store.state.islhurl}lov/ipms/options?lovCodes=${encodeURIComponent(lovCodes)}`
      this._get(lovUrl).then(res => {
        if (res.code === 200 && res.data) {
          const sortByOrder = (arr) => (arr || []).sort((a, b) => (a.orderSeq || 0) - (b.orderSeq || 0))
          this.industryList = sortByOrder(res.data['HPFM.SUB_INDUSTRY'])
          this.repOfficeList = sortByOrder(res.data['HPFM.OVERSEA_COUNTRY'])
        }
      }).catch(() => {})
    },
    // 等级样式映射
    getLevelClass(level) {
      if (!level) return ''
      const l = level.toLowerCase()
      if (l.includes('strategic')) return 'strategic'
      if (l.includes('mid')) return 'mid-tier'
      if (l.includes('bottom')) return 'bottom-tier'
      if (l.includes('key')) return 'key'
      if (l.includes('standard')) return 'standard'
      if (l.includes('developing')) return 'developing'
      return ''
    },
    // 用户远程搜索（与 riskManagement 同模式）
    filterUser(list, query) {
      if (query !== '') {
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => {
          this.fetchUserOptions(list, query)
        }, 200)
      } else {
        this[list] = []
      }
    },
    fetchUserOptions(list, query) {
      let url = `${this.$store.state.islhurl}user/select-option?keyword=${query}`
      this._get(url).then().then(res => {
        if (res.code === 200 && res.data) {
          this[list] = res.data
        } else {
          this[list] = []
        }
      }).catch(() => {
        this[list] = []
      })
    },
    // 排序字段映射：前端 prop → 后端 camelCase
    _mapSortField(prop) {
      const map = {
        accountName: 'accountName',
        repOffice: 'country',
        country: 'country',
        serviceNo: 'gtsCode',
        gtsCode: 'gtsCode',
        accountLevel: 'accountLevel',
        industry: 'accountIndustry',
        accountIndustry: 'accountIndustry',
        marketingKA: 'marketingKa',
        marketingKa: 'marketingKa',
        wla: 'wla',
        vipCode: 'vipCode',
      }
      return map[prop] || prop
    },
    handleSearch() {
      this.currentPage = 1
      this._doSearch()
    },
    _doSearch() {
      const values = this.searchForm
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        country: values.repOffice || undefined,
        accountName: values.accountName || undefined,
        gtsCode: values.serviceNo || undefined,
        accountLevel: values.accountLevel || undefined,
        accountIndustry: values.industry || undefined,
        marketingKa: values.marketingKA || undefined,
        // wla: values.wla === 'Yes' ? true : (values.wla === 'No' ? false : undefined),
        vipCode: values.vipCode || undefined,
        accountCreateTimeStart: values.creationTime ? moment(values.creationTime[0]).format('YYYY-MM-DD') : undefined,
        accountCreateTimeEnd: values.creationTime ? moment(values.creationTime[1]).format('YYYY-MM-DD') : undefined,
        sortField: this.sortField ? this._mapSortField(this.sortField) : undefined,
        sortOrder: this.sortOrder === 'ascending' ? 'asc' : (this.sortOrder === 'descending' ? 'desc' : undefined),
      }
      // Remove undefined values
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === '') delete params[key]
      })

      this.tableLoading = true
      let url = `${this.$store.state.islhurl}valued-account/list`
      this.$axios.get(url, { params }).then(res => {
        this.tableLoading = false
        const data = res.data
        if (data.code === 200) {
          this.tableData = data.data || []
          this.totalCount = data.totalSize || 0
        } else {
          this.tableData = []
          this.totalCount = 0
          this.$message.error(data.msg || 'Failed!')
        }
      }).catch(() => {
        this.tableLoading = false
        this.tableData = []
        this.totalCount = 0
      })
    },
    changePageSize(size) {
      this.pageSize = size
      this.handleSearch()
    },
    changePage(current) {
      this.currentPage = current
      this._doSearch()
    },
    handleReset() {
      this.searchForm = {}
      this.sortField = ''
      this.sortOrder = ''
      this.currentPage = 1
      this._doSearch()
    },
    handleSortChange({ prop, order }) {
      this.sortField = order ? (prop || '') : ''
      this.sortOrder = order || ''
      this._doSearch()
    },
    handleExport() {
      this.exportLoading = true
      const values = this.searchForm
      let params = {
        country: values.repOffice || undefined,
        accountName: values.accountName || undefined,
        gtsCode: values.serviceNo || undefined,
        accountLevel: values.accountLevel || undefined,
        accountIndustry: values.industry || undefined,
        marketingKa: values.marketingKA || undefined,
        // wla: values.wla === 'Yes' ? true : (values.wla === 'No' ? false : undefined),
        vipCode: values.vipCode || undefined,
        accountCreateTimeStart: values.creationTime ? moment(values.creationTime[0]).format('YYYY-MM-DD') : undefined,
        accountCreateTimeEnd: values.creationTime ? moment(values.creationTime[1]).format('YYYY-MM-DD') : undefined,
      }
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === '') delete params[key]
      })

      this.$axios({
        url: `${this.$store.state.islhurl}valued-account/export`,
        method: 'get',
        params,
        responseType: 'blob'
      }).then(response => {
        this.exportLoading = false
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = 'InformationManagement_' + moment().format('YYYYMMDD') + '.xlsx'
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.exportLoading = false
        this.$message.error('Export failed!')
      })
    },
    handleDetail(row) {
      this.$router.push({ name: 'accountDetail', params: { id: row.id }, query: { from: 'informationManagement' } })
    },
    handleModify(row) {
      this.asmSearchList = []
      this.engineerSearchList = []
      this.modifyForm = {
        id: row.id,
        country: row.country,
        accountName: row.accountName,
        gtsCode: row.gtsCode,
        accountIndustry: row.accountIndustry,
        marketingKa: row.marketingKa,
        // wla: row.wla,
        accountLevel: row.accountLevel,
        vipCode: row.vipCode,
        asmList: [],
        engineerList: [],
      }
      // 获取详情以回显 ASM/工程师列表
      let url = `${this.$store.state.islhurl}valued-account/${row.id}`
      this.$axios.get(url).then(res => {
        const data = res.data
        if (data.code === 200 && data.data) {
          const detail = data.data
          const asmList = detail.asmList || []
          const engineerList = detail.engineerList || []
          this.modifyForm.asmList = asmList.map(u => u.empCode)
          this.modifyForm.engineerList = engineerList.map(u => u.empCode)
          // 通过 batch-get 接口批量获取用户信息以支持回显
          const allEmpCodes = [...new Set([...asmList.map(u => u.empCode), ...engineerList.map(u => u.empCode)])]
          if (allEmpCodes.length > 0) {
            let batchUrl = `${this.$store.state.islhurl}user/batch-get`
            this._post(batchUrl, { empCodeList: allEmpCodes }).then(res2 => {
              if (res2.code === 200 && res2.data) {
                const users = res2.data || []
                const asmCodes = new Set(asmList.map(u => u.empCode))
                const engineerCodes = new Set(engineerList.map(u => u.empCode))
                this.asmSearchList = users.filter(u => asmCodes.has(u.empCode))
                this.engineerSearchList = users.filter(u => engineerCodes.has(u.empCode))
              }
            }).catch(() => {})
          }
        }
      }).catch(() => {})
      this.modifyVisible = true
      this.$nextTick(() => {
        if (this.$refs.modifyForm) this.$refs.modifyForm.clearValidate()
      })
    },
    saveModify() {
      this.$refs.modifyForm.validate(valid => {
        if (!valid) return
        this.modifyLoading = true
        let url = `${this.$store.state.islhurl}valued-account/${this.modifyForm.id}`
        let params = {
          accountLevel: this.modifyForm.accountLevel,
          vipCode: this.modifyForm.vipCode || '',
          asmList: this.modifyForm.asmList || [],
          engineerList: this.modifyForm.engineerList || [],
        }
        this.$axios.put(url, params).then(res => {
          this.modifyLoading = false
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Save successful!')
            this.modifyVisible = false
            this.handleSearch()
          } else {
            this.$message.error(data.msg || 'Save failed!')
          }
        }).catch(() => {
          this.modifyLoading = false
          this.$message.error('Save failed!')
        })
      })
    },
    checkOperationPermission() {
      let buttonpermsStr = localStorage.getItem("userRolePerm") || sessionStorage.getItem("userRolePerm")
      let buttonperms = JSON.parse(buttonpermsStr)
      if (buttonperms && Array.isArray(buttonperms)) {
        this.hasOperationPermission = buttonperms.some(p => p.indexOf('valuedAccountEdit') > -1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
#informationManagement {
  .btn-col {
    padding: 30px 0 0 0px;
  }
  .btn-col-lg24 {
    padding-top: 20px;
  }
  .level-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
  }
  .level-strategic {
    background: #FFF1F0;
    color: #F5222D;
    border: 1px solid #FFA39E;
  }
  .level-key {
    background: #FFF7E6;
    color: #FA8C16;
    border: 1px solid #FFD591;
  }
  .level-mid-tier {
    background: #FFF7E6;
    color: #FA8C16;
    border: 1px solid #FFD591;
  }
  .level-standard {
    background: #E6F7FF;
    color: #1890FF;
    border: 1px solid #91D5FF;
  }
  .level-bottom-tier {
    background: #E6F7FF;
    color: #1890FF;
    border: 1px solid #91D5FF;
  }
  .level-developing {
    background: #F5F5F5;
    color: #8C8C8C;
    border: 1px solid #D9D9D9;
  }
  .el-form {
    padding: 20px 0 20px 0;
    .el-form-item {
      margin-bottom: 0px;
      padding: 0 15px 0 0;
    }
    /deep/.el-form-item__label {
      line-height: 22px;
      padding: 9px 12px 0px 0px;
    }
    /deep/.el-select {
      width: 100%;
    }
    /deep/.el-form-item__content .el-input__suffix {
      left: auto;
      right: 10px;
    }
    /deep/.el-range-editor.el-input__inner {
      width: 100%;
    }
  }
  .el-table {
    /deep/th.el-table__cell > .cell {
      word-break: break-word;
    }
  }
  /deep/.el-form-item__error {
    padding-top: 0;
  }
  /deep/.el-dialog__body {
    padding: 10px 20px;
    .el-form {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/informationManagement.vue